import { Fit, Layout, Rive } from '@rive-app/canvas-lite'
import rewardRiv from '~/assets/rive/reward.riv'
import { onCleanup, onMount } from 'solid-js'

const REVEAL_STATE_MACHINE = 'State Machine 1'

/** Which reveal animation the shared reward.riv backdrop plays. */
export type RewardRevealVariant = 'coin' | 'gem' | 'tree'

// The `status` input of reward.riv's `reward_reveal` state machine (shared
// with referral and focus-pass): coins = 1, gems = 2, everything else = 3.
const revealStatus: Record<RewardRevealVariant, number> = {
  coin: 1,
  gem: 2,
  tree: 3,
}

/** The animated rive halo behind a revealed reward (referral's reveal). */
export function RewardRevealBackdrop(props: { variant: RewardRevealVariant }) {
  let canvas: HTMLCanvasElement | undefined
  let rive: Rive | undefined

  onMount(() => {
    if (!canvas) return
    rive = new Rive({
      canvas,
      src: rewardRiv,
      artboard: 'reward_reveal',
      stateMachines: [REVEAL_STATE_MACHINE],
      autoplay: true,
      shouldDisableRiveListeners: true,
      layout: new Layout({ fit: Fit.FitHeight }),
      onLoad: () => {
        rive?.resizeDrawingSurfaceToCanvas()
        for (const input of rive?.stateMachineInputs(REVEAL_STATE_MACHINE) ??
          []) {
          if (input.name === 'status') input.value = revealStatus[props.variant]
          // `repeat` drives focus-pass's duplicate-item fallback; unused here.
          if (input.name === 'repeat') input.value = false
        }
      },
    })
    const onResize = () => rive?.resizeDrawingSurfaceToCanvas()
    window.addEventListener('resize', onResize)
    onCleanup(() => {
      window.removeEventListener('resize', onResize)
      rive?.cleanup()
    })
  })

  return (
    // The artboard is wider than the square anchor the reveals centre it in,
    // and FitHeight clips at the canvas edge — so the canvas bleeds to the
    // full viewport width (the anchor is viewport-centred, and hosts must
    // not clip overflow).
    <canvas
      ref={(element) => {
        canvas = element
      }}
      aria-hidden="true"
      class="absolute left-1/2 top-0 h-full w-screen -translate-x-1/2"
    />
  )
}
